import { useState } from 'react';

import { animateAppearance } from '../services/animations';

export const useAnimateAppearance = () => {
  const [isAnimating, setIsAnimating] = useState(false);

  const makeAnimation = (type: 'appear' | 'disappear') => (el: HTMLDivElement) => {
    setIsAnimating(true);
    const animation = animateAppearance(el, type);
    if (!animation) {
      setIsAnimating(false);
      return Promise.resolve();
    }
    return animation.finished.then(() => setIsAnimating(false));
  };

  return { isAnimating, appear: makeAnimation('appear'), disappear: makeAnimation('disappear') };
};
